/**
 * HomeSection — slim composed home dashboard.
 *
 * Replaces the legacy inline `HomeSection` function inside DesktopLayout.tsx.
 * Just stacks ShiftSummary on top of ShiftDetails — all the actual logic
 * lives in those two children.
 */
import ShiftSummary from './ShiftSummary'
import ShiftDetails from './ShiftDetails'

export default function HomeSection() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <ShiftSummary />
      <ShiftDetails />
    </div>
  )
}
